/** Значення query `view` сторінки порівняння для режиму лот-позицій */
export const COMPARE_VIEW_LOT_GROUPS = 'lotGroups'

/** Ключ учасника агрегованого рядка режиму лот-позицій */
export function lotGroupSupplierKey(item) {
  return item.positions?.[0]?.participant || item.bidderInfo?.contactId || item.bidderInfo?.usreou
}

/** Ключ агрегованого рядка «учасник × лот» — стабільний між перечитуваннями тендеру */
export function lotGroupItemKey(item) {
  return `${lotGroupSupplierKey(item)}_${item.groupId ?? item.lotGroupNumber}`
}

/**
 * Розгортає positions агрегованих рядків режиму лот-позицій
 * (див. tenderMixin.$_getGroupsPositionsByLot) без дублів по idBidRow
 *
 * @param {Array} elements агреговані рядки ({ positions: [...] })
 * @returns {Array} позиції
 */
export function flattenLotGroupPositions(elements) {
  return Object.values(
    (elements || [])
      .flatMap(item => item?.positions || [])
      .reduce((acc, currentPos) => {
        if (currentPos && currentPos.idBidRow && !acc[currentPos.idBidRow]) {
          acc[currentPos.idBidRow] = currentPos
        }
        return acc
      }, {})
  )
}
